var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-plus_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.512 7.512h-5.024V2.488A2.484 2.484 0 0 0 10 0a2.484 2.484 0 0 0-2.488 2.488v5.024H2.488A2.484 2.484 0 0 0 0 10a2.484 2.484 0 0 0 2.488 2.488h5.024v5.024A2.484 2.484 0 0 0 10 20a2.484 2.484 0 0 0 2.488-2.488v-5.024h5.024A2.484 2.484 0 0 0 20 10a2.484 2.484 0 0 0-2.488-2.488"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-plus_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIcPlus;